import {Divider} from '@/components/ui/divider/Divider'
import {ProjectFormDetailsSection} from '@/features/projects/components/project-form/project-form-details-section/ProjectFormDetailsSection'
import {ProjectFormPatientSection} from '@/features/projects/components/project-form/project-form-patient-section/ProjectFormPatientSection'
import {ProjectFormReferringSpecialistSection} from '@/features/projects/components/project-form/project-form-referring-specialist-section/ProjectFormReferringSpecialistSection'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {CreateProjectUrlParams, ProjectCreationError} from '@/features/projects/types'
import {QUERY_KEYS} from '@/queryClient'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {useIsFetching} from '@tanstack/react-query'
import {useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

interface CreateProjectFormSectionsProps {
    isOriginTreatmentRequest?: boolean
}

const CreateProjectFormSectionsSchema = ProjectFieldsSchema.pick({
    patient: true
})
type CreateProjectFormSectionsSchema = z.infer<typeof CreateProjectFormSectionsSchema>

export const CreateProjectFormSections = ({isOriginTreatmentRequest}: CreateProjectFormSectionsProps) => {
    const {control} = useFormContext<CreateProjectFormSectionsSchema>()
    const [error, setError] = useState<ProjectCreationError | null>(null)
    const {searchParams} = useParsedSearchParams(CreateProjectUrlParams)
    const isLoadingPatient = useIsFetching({
        queryKey: [QUERY_KEYS.PATIENTS, searchParams.patientId]
    })

    const watchPatient = useWatch({control, name: 'patient'})

    return (
        <>
            <ProjectFormPatientSection
                showPatientSelect={!isOriginTreatmentRequest}
                error={error}
                setError={setError}
            />
            {!error && watchPatient && !isLoadingPatient && (
                <>
                    <Divider direction="horizontal" />
                    <ProjectFormDetailsSection />
                    <ProjectFormReferringSpecialistSection />
                </>
            )}
        </>
    )
}
